// @flow

import { createReducer } from 'redux-act';

import type { State, RenewableProductApiResponse } from '../types';

import { setRenewableProducts } from './actions';

const initialState: State = [];

const setRenewableProductsHandler = (
  state: State,
  data: Array<RenewableProductApiResponse>,
): State => data;

export default (createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setRenewableProducts]: setRenewableProductsHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
